const prefetched = new Set<string>()

/**
 * Hints the browser to fetch a page ahead of time so it opens instantly
 * when the user clicks. Safe to call repeatedly — each URL is added once.
 * Skipped on data-saver / very slow connections.
 */
export function prefetchPage(href: string) {
  if (typeof document === 'undefined' || prefetched.has(href)) return

  const connection = (
    navigator as Navigator & {
      connection?: { saveData?: boolean; effectiveType?: string }
    }
  ).connection
  if (connection?.saveData || connection?.effectiveType === '2g') return

  prefetched.add(href)
  const link = document.createElement('link')
  link.rel = 'prefetch'
  link.href = href
  link.as = 'document'
  document.head.appendChild(link)
}

/** Runs a callback when the browser is idle (falls back to a timeout). */
export function whenIdle(callback: () => void, timeout = 2500) {
  if (typeof window === 'undefined') return
  const w = window as Window & {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
  }
  if (w.requestIdleCallback) w.requestIdleCallback(callback, { timeout })
  else window.setTimeout(callback, 1200)
}
